module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ribbon/ribbon.component.scss
// module id = ./src/app/features/ribbon/ribbon.component.scss
// module chunks = main